import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { CartProvider, useCart } from './context/CartContext';
import { initGA, logPageView } from './utils/analytics';
import CartDrawer from './Components/CartDrawer';
import CookieConsent from './Components/CookieConsent';
import Home from './Components/pages/Home';
import Collection from './Components/pages/Collection';
import ProductDetail from './Components/pages/ProductDetail';
import InfoPage from './Components/pages/Infopage';
import Checkout from './Components/pages/Checkout';
import OrderConfirmation from './Components/pages/OrderConfrimation';
import Admin from './Components/pages/Admin';
import SmoothScroll from './Components/Smoothscroll';

// Analytics wrapper component
function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    // Only log page view if user has accepted cookies
    const consent = localStorage.getItem('rtk-cookie-consent');
    if (consent === 'accepted') {
      logPageView(location.pathname + location.search);
    }
  }, [location]);

  return null;
}

function AppContent() {
  const { isCartOpen, closeCart, cartItems, updateQuantity, removeItem } = useCart();

  return (
    <>
      <AnalyticsTracker />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path="/collection" element={<Collection />} />
        <Route path='/product/:id' element={<ProductDetail />} />
        <Route path='/checkout' element={<Checkout />} />
        <Route path='/order-confirmation' element={<OrderConfirmation />} />
        <Route path='/admin' element={<Admin />} />
        <Route path="/:slug" element={<InfoPage />} />
      </Routes>
      
      <CartDrawer
        isOpen={isCartOpen}
        onClose={closeCart}
        cartItems={cartItems}
        updateQuantity={updateQuantity}
        removeItem={removeItem}
      />
      
      <CookieConsent />
    </>
  ); 
}

function App() {
  // Initialize Google Analytics once on app load
  useEffect(() => {
    // Only fully initialize if user has already accepted
    const consent = localStorage.getItem('rtk-cookie-consent');
    if (consent === 'accepted') {
      initGA();
    }
  }, []);

  return (
    <CartProvider>
      <Router>
        <SmoothScroll>
          <AppContent />
        </SmoothScroll>
      </Router>
    </CartProvider>
  );
}

export default App;